import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-stage',
  templateUrl: './stage.component.html',
  styleUrls: ['./stage.component.scss']
})
export class StageComponent implements OnInit {

  additionalInfo: boolean = false;
  stage: string ='';
  constructor(public route: ActivatedRoute) {
    this.stage = this.route.snapshot.paramMap.get('stageName');

    if(this.stage == 'additionalInfo'){
      this.additionalInfo = true;
    }
  }

  ngOnInit() {
  }

}
